import * as React from "react";
import { VBox } from "../structural_components/hbox_vbox";
var LoadingSpinner = function () {
    return React.createElement(VBox, null, 'Načítá se...');
};
var LoadingError = function () {
    return React.createElement(VBox, null, "Při načítání stránky došlo k chybě.");
};
export { LoadingSpinner, LoadingError, };
